// extracted by mini-css-extract-plugin
export var searchHeader = "_3w-0";
export var searchHeaderDark = "_3w-1";